/* eslint-disable react-hooks/exhaustive-deps */
import * as motion from "motion/react-client";
import { appearanceAnimation } from "../../../utils/animations";
import haLongBayImg from "../../../assets/home/ha_long_bay.jpg";

import { useTranslation } from "react-i18next";
import { Select } from "antd";
import { useNavigate } from "react-router";
import { path } from "../../../utils/common/constant";
import { useEffect, useState } from "react";
const HeroSectionNew = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [typeVisa, setTypeVisa] = useState<string>("OneMonthSingle");
  const [processingTime, setProcessingTime] = useState<string>("Standard");
  const [totalServiceFee, setTotalServiceFee] = useState<number>(0);

  const visaEntryTypeFeeMap = new Map([
    ["OneMonthSingle", 54],
    ["OneMonthMultiple", 84],
    ["ThreeMonthSingle", 94],
    ["ThreeMonthMultiple", 104],
  ]);
  const processingTimeFeeMap = new Map([
    ["Standard", 0],
    ["Express", 45],
    ["Urgent", 85],
  ]);

  useEffect(() => {
    if (!typeVisa || !processingTime) {
      return;
    }

    const visaFee = visaEntryTypeFeeMap.get(typeVisa) || 0;
    const processingFee = processingTimeFeeMap.get(processingTime) || 0;

    setTotalServiceFee(visaFee + processingFee);
  }, [typeVisa, processingTime]);

  const handleApply = () => {
    if (!typeVisa || !processingTime) {
      return;
    }
    navigate(path.VISA_APPLICATION, {
      state: {
        typeVisa,
        processingTime,
      },
    });
  };
  return (
    <div
      className="relative h-[800px] max-sm:h-[700px] flex justify-center items-center bg-cover sm:bg-cover"
      style={{
        backgroundImage: `url(${haLongBayImg})`,
      }}
    >
      <div className="absolute inset-0 bg-black/40 z-0" />

      {/* <motion.div
        {...appearanceAnimation("left")}
        className="absolute xl:top-10 lg:top-8 top-6 xl:left-16 lg:left-12 left-8"
      >
        <LazyLoadImage
          src={birdsImage}
          alt="Birds Image"
          effect="blur"
          className="xl:w-full lg:w-[70%] w-[50%] h-full object-cover"
        />
      </motion.div> */}

      <div className="w-full h-full max-w-[1290px] flex px-6">
        {/* Left Section */}
        <div className="relative w-full h-full flex justify-center items-center">
          <motion.div
            {...appearanceAnimation("bottom")}
            className="flex flex-col z-10"
          >
            {/* <div className="w-full text-white font-regular text-3xl p-2">
              <span className="text-primary-lightyellow font-bold">
                5 Minutes
              </span>{" "}
              Visa Application:{" "}
              <span className="text-primary-lightyellow font-bold">
                SCAN - VERIFY - PAY
              </span>
            </div>
            <p className="font-bold text-3xl md:text-[40px] 2xl:text-[60px] leading-tight text-white z-10 pb-8 md:pb-16 drop-shadow-lg">
              {t("home.welcome")}
            </p> */}
            <p className="font-bold text-3xl md:text-[40px] 2xl:text-[60px] leading-tight text-white z-10 drop-shadow-lg">
              <span className="text-primary-lightyellow font-bold md:text-[55px] 2xl:text-[75px]">
                {t("home.visa_time")}
              </span>{" "}
              {t("home.visa_application")} <br />
              <span className="text-primary-lightyellow font-bold md:text-[35px] 2xl:text-[50px]">
                {t("home.visa_steps")}
              </span>
            </p>
            <div className="w-full text-white font-regular text-3xl py-2 pb-8 md:pb-16">
              {t("home.welcome")}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="">
                {/* First row: Two selects */}
                <div className="flex flex-col">
                  <label className="text-white font-bold text-lg md:text-xl mb-2">
                    {t("home.visa_type")}
                  </label>
                  <Select
                    size="large"
                    className="mb-4"
                    value={typeVisa}
                    onChange={(value) => setTypeVisa(value)}
                  >
                    <Select.Option value="OneMonthSingle">
                      1 month - Single Entry
                    </Select.Option>
                    <Select.Option value="OneMonthMultiple">
                      1 month - Multiple Entries
                    </Select.Option>
                    <Select.Option value="ThreeMonthSingle">
                      3 months - Single Entry
                    </Select.Option>
                    <Select.Option value="ThreeMonthMultiple">
                      3 months - Multiple Entries
                    </Select.Option>
                  </Select>
                </div>

                <div className="flex flex-col">
                  <label className="text-white font-bold text-lg md:text-xl mb-2">
                    {t("home.processing_time")}
                  </label>
                  <Select
                    size="large"
                    className="mb-4"
                    value={processingTime}
                    onChange={(value) => setProcessingTime(value)}
                  >
                    <Select.Option value="Standard">
                      Standard (5-10 days)
                    </Select.Option>
                    <Select.Option value="Express">
                      Express (2 days)
                    </Select.Option>
                    <Select.Option value="Urgent">Urgent (1 day)</Select.Option>
                  </Select>
                </div>
              </div>

              <div className="flex flex-col gap-4 justify-center items-center">
                <p className="text-white font-bold text-4xl">
                  <span>Total:</span>{" "}
                  <span className="text-orange-500 text-6xl">
                    ${totalServiceFee}
                  </span>
                </p>
                <button
                  type="button"
                  className="w-fit h-fit px-10 py-4 text-xl justify-center items-center bg-primary-lightyellow hover:bg-primary-yellow text-primary-blue border-none rounded-full font-semibold"
                  onClick={() => handleApply()}
                >
                  {t("cta.apply_visa")}
                </button>
              </div>
            </div>
          </motion.div>

          {/* <div className="absolute lg:bottom-10 md:bottom-32 bottom-10 -right-4">
            <LazyLoadImage
              src={vietnamMap}
              alt="Vietnam Map"
              effect="blur"
              className="xl:w-full lg:w-[80%] w-[90%] h-full object-cover"
            />
          </div> */}
        </div>

        {/* Right Section */}
        {/* <motion.div
          {...appearanceAnimation("right")}
          className="flex lg:items-end items-center w-full h-full max-md:hidden"
        >
          <LazyLoadImage
            src={mainBanner}
            alt="Main Banner"
            effect="blur"
            className="w-full h-full object-cover rounded-t-[2.5rem]"
          />
        </motion.div> */}
      </div>
    </div>
  );
};

export default HeroSectionNew;
